import * as React from "react";
import { Helmet } from "react-helmet";
import { useStaticQuery, graphql } from "gatsby";
import { useTranslation } from "@herob191/gatsby-plugin-react-i18next";

export default function Seo({ meta = [], title = "" }) {
	const { language } = useTranslation();
	const { siteData } = useStaticQuery(graphql`
		query {
			siteData: site {
				siteMetadata {
					langs {
						description
						lang
						name
						short_name
					}
				}
			}
		}
	`);

	const metadata =
		siteData?.siteMetadata?.langs?.find((item) => item?.lang === language) ||
		siteData?.siteMetadata?.langs[0];

	return (
		<Helmet
			htmlAttributes={{
				language,
			}}
			title={title || metadata.name}
			titleTemplate={title ? `%s. ${metadata.name}` : `${metadata.name}`}
			meta={[
				{
					name: `description`,
					content: metadata.description,
				},
				{
					property: `og:title`,
					content: metadata.name,
				},
				{
					property: `og:description`,
					content: metadata.description,
				},
				{
					property: `og:type`,
					content: `website`,
				},
				{
					name: `twitter:card`,
					content: `summary`,
				},
				{
					name: `twitter:creator`,
					content: metadata.short_name,
				},
				{
					name: `twitter:title`,
					content: metadata.name,
				},
				{
					name: `twitter:description`,
					content: metadata.description,
				},
			].concat(meta)}
		/>
	);
}
